import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { lastValueFrom } from "rxjs";
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { LoteCertificadoService } from "src/app/core/services/lote-certificado.service";
import { LoteService } from "src/app/core/services/lote.service";
import { UsuariosService } from "src/app/core/services/usuarios.service";
import { PlantillasService } from "src/app/core/services/plantilla.service";
import { FirmaStateService } from "src/app/core/states/firma/firma-state.service";
import { Lote } from "src/app/models/Lote.model";
import { LoteCertificado } from "src/app/models/LoteCertificado.model";
import { PlantillaCoordenada } from "src/app/models/PlantillaCoordenada.model";
import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { HelpToursService } from "src/app/core/tours/help-tours.service";
import { SearchCertificateComponent } from "src/app/shared/components/search-certificate/search-certificate";

interface Item {
  id_usuario_grupo?: string;
  grupo: string;
  nombre: string;
}

@Component({
  selector: "lote-certificado-component",
  templateUrl: "./lote-certificado.html",
  styleUrls: ["./lote-certificado.css"],
})
export class LoteCertificadoComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  public loteCertificados: LoteCertificado[] = [];
  public maxOrdenCertificado: number = 0;
  public loteCertificadosGroup: any[] = [];
  private idLote: any = null;
  lote: Lote;
  public plantillaCoordenadas: PlantillaCoordenada[];
  public formAsociarCertificado: FormGroup;
  public userGroup: any[] = [];
  public userArrayExcluir: string[] = [];
  public arrayIdUserGroup: string[] = [];
  public btnDisabled: boolean = false;
  // UserGroup Table
  currentItems: Item[] = []; // Los datos para la página actual
  currentPage: number = 1;
  pageSize: number = 10; // Tamaño de página inicial
  totalItems: number = 0;
  spinner: boolean;
  idGroup: string;
  es_grupo: boolean;
  private certificadoClicked = false;
  modalIsOpen: boolean = false;
  asigCargo: boolean = true;

  tableHeaders = [
    { key: "nombre", label: "Nombre" },
    { key: "correo", label: "Correo" },
    { key: "grupo", label: "Grupo" },
  ];

  customActions: TableAction[] = [];

  // Toast
  toast = Swal;
  btnDisable: boolean = false;

  @ViewChild("certificadoBtn", { static: false })
  certificadoBtn!: ElementRef<HTMLButtonElement>;
  @ViewChild("searchCertificate")
  searchCertificateComponent?: SearchCertificateComponent;

  constructor(
    private loteCertificadoService: LoteCertificadoService,
    private firmaStateService: FirmaStateService,
    private modalService: NgbModal, // ¡Inyecta el servicio NgbModal!
    private loteService: LoteService,
    private plantillaService: PlantillasService,
    private usurioService: UsuariosService,
    private fb: FormBuilder,
    private tours: HelpToursService,
  ) {}

  ngOnDestroy(): void {
    this.tours.stop();
  }

  async ngOnInit() {
    this.toastAlert();
    this.customActions = [
      {
        label: "Editar",
        handler: (item: Item) => this.excluirUserGroup(item),
        icon: "fa-solid fa-lock-open",
        colorClass: "bg-orange",
      },
    ];
    this.formAsociarCertificado = this.fb.group({
      id_plantilla_coordenada: new FormControl(null, [Validators.required]),
      id_certificado: new FormControl("", [Validators.required]),
    });

    this.lote = this.firmaStateService.getCurrentState()?.lote;
    this.es_grupo = this.lote.es_grupo;
    this.idLote = this.lote?.id;

    if (this.es_grupo) {
      await this.indexLoteCertificadoGroup();
    }

    if (this.lote.plantilla) {
      await this.getPlantillaCoordenadas();
    }

    this.getEsGrupo();
  }

  async ngAfterViewInit() {
    this.lote = this.firmaStateService.getCurrentState()?.lote;
    this.es_grupo = this.lote.es_grupo;
    this.idLote = this.lote?.id;
    if (!this.es_grupo) {
      this.activarCertificados();
    } else {
      await this.indexLoteCertificado();
    }
    this.onHelp(false);
  }

  onHelp(force = false) {
    if (this.modalIsOpen) return;

    // Muestra ayuda según contexto de firma grupal
    if (this.es_grupo) {
      this.tours.start("case1_firma_asociacion_grupos_help", force);
    } else {
      this.tours.start("case2_firma_asociacion_sin_plantilla_help", force);
    }
  }

  async indexLoteCertificado() {
    const response = await lastValueFrom(
      this.loteCertificadoService.indexLoteCertificado(this.idLote),
    );
    this.loteCertificados = response.body as LoteCertificado[];    
    this.maxOrdenCertificado = this.loteCertificados.length;
    this.firmaStateService.updateLoteCertificado(this.loteCertificados);
    return this.loteCertificados;
  }

  async validar() {
    let sinAsignar = this.loteCertificados.find((x: any) => {
      return (
        x.loteDetalleUrlCoordenada &&
        Array.isArray(x.loteDetalleUrlCoordenada) &&
        x.loteDetalleUrlCoordenada.length == 0
      );
    });
    return sinAsignar ? false : true;
  }

  async indexLoteCertificadoGroup() {
    const response = await lastValueFrom(
      this.loteCertificadoService.indexLoteCertificadoGrupo(this.idLote),
    );
    this.loteCertificadosGroup = response.body as LoteCertificado[];
  }

  async getPlantillaCoordenadas() {
    const response = await lastValueFrom(
      this.plantillaService.getCordenadasPlantilla(this.lote.plantilla.id),
    );
    this.plantillaCoordenadas = response.body as PlantillaCoordenada[];
  }

  validateCargo() {
    const coordenadaSeleccionada = this.formAsociarCertificado.get(
      "id_plantilla_coordenada",
    )?.value;

    if (!coordenadaSeleccionada) {
      return;
    }

    const existeCoordenada = this.loteCertificados.find((cert: any) =>
      cert.loteDetalleUrlCoordenada?.some(
        (coord: any) =>
          String(coord.coordenada) ===
          String(coordenadaSeleccionada.coordenada),
      ),
    );

    if (existeCoordenada) {
      this.asigCargo = false;
      this.alert(
        "warning",
        "Asignación duplicada",
        `Esta firma ya está asignada al usuario: ${existeCoordenada.usuario.username}`,
      );
    } else {
      this.asigCargo = true;
    }
  }

  async eliminarLoteCertificado(loteCertificado: any) {
    Swal.fire({
      title: "¡Eliminación de Certificado!",
      text: "¿Deseas eliminar este certificado?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await lastValueFrom(
          this.loteCertificadoService.deleteCertificado(
            this.idLote,
            loteCertificado.id,
          ),
        );
        await this.indexLoteCertificadoGroup();
        await this.indexLoteCertificado();

        this.alert("success", "Certificado eliminado correctamente");
      }
    });
  }

  async eliminarGrupoCertificado(grupoCertificado: any) {
    Swal.fire({
      title: "¡Eliminación certificado de Grupo!",
      text: "¿Deseas eliminar este Grupo?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await lastValueFrom(
          this.loteCertificadoService.deleteGrupoCertificado(
            this.idLote,
            grupoCertificado.id_grupo,
          ),
        );
        await this.indexLoteCertificado();
        await this.indexLoteCertificadoGroup();

        this.alert("success", "Grupo eliminado correctamente");
      }
    });
  }

  async openBusquedaCertificado(content: any) {
    this.onHelpBuscarCertificado();
    this.openModal(content);
  }

  async openBusquedaGrupos(content: any) {
    this.openModal(content);
    this.onHelpModalAgregarGrupo();
  }

  onHelpModalAgregarGrupo(force = false) {
    if (this.es_grupo) {
      this.tours.start("modal_agregar_grupos_help", force);
    }
  }

  async openAsociacionCertificadoCoordenada(
    content: any,
    certificadoId: number,
  ) {
    this.openModal(content);
    this.formAsociarCertificado.setValue({
      ...this.formAsociarCertificado.value,
      id_certificado: certificadoId,
    });
  }

  openModal(content: any) {
    this.modalService.open(content, { centered: true, size: "xl" });
    this.modalIsOpen = true;
  }

  async agregarCertificadoLote(certificado: any) {
    this.btnDisabled = true;
    const yaExiste = this.loteCertificados.some(
      (x: any) => x.usuario.id === certificado.data.usuario.id,
    );
    if (yaExiste) {
      this.btnDisabled = false;
      this.alert(
        "warning",
        "Certificado ya asignado",
        "El usuario ya tiene un certificado asignado. Si desea cambiarlo, elimine el actual.",
      );
      return;
    }

    if (this.lote.firma_por_plantilla) {
      const countCoorPlantilla = this.plantillaCoordenadas.length;
      const countCertificados = this.loteCertificados.length;

      if (countCoorPlantilla === countCertificados) {
        this.btnDisabled = false;
        this.alert(
          "warning",
          `La plantilla seleccionada solo permite ${countCoorPlantilla} certificado(s)`,
        );
        return;
      }
    }

    const body = { firmar_con_imagen: certificado.firmaImg };
    await lastValueFrom(
      this.loteCertificadoService.putLoteCertificado(
        body,
        this.idLote,
        certificado.data.id,
      ),
    );
    this.btnDisabled = false;
    this.alert("success", "Certificado agregado correctamente");
    this.modalService.dismissAll();
    this.indexLoteCertificado();
    if (this.es_grupo) {
      await this.indexLoteCertificadoGroup();
    }
  }

  onHelpBuscarCertificado(force = false) {
    this.tours.start("modal_agregar_certificado_busqueda_help", force);
  }

  async validCantidadCertificados(): Promise<boolean> {
    // Validación principal (siempre)
    if (this.loteCertificados.length === 0) {
      this.alert("warning", "Debe agregar certificados antes de continuar.");
      return false;
    }

    // Validación adicional solo para firma por plantilla
    if (this.lote.firma_por_plantilla) {
      const validarGrupo = await this.validar();

      if (!validarGrupo) {
        this.alert(
          "warning",
          "Debe asociar todos los certificados antes de continuar.",
        );
        return false;
      }
    }

    return true;
  }

  async asociarFirmaCertificado() {
    if (!this.formAsociarCertificado.valid) {
      this.alert("warning", "Campo requerido", "Debe seleccionar una firma");
      return;
    }

    this.btnDisable = true;
    const formValue = this.formAsociarCertificado.value;

    // 👇 Aquí convertimos el objeto en solo el id
    const payload = {
      ...formValue,
      id_plantilla_coordenada: formValue.id_plantilla_coordenada.id,
    };

    await lastValueFrom(
      this.loteService.addCertificadoCoordenadaPlantilla(payload, this.lote.id),
    );

    this.indexLoteCertificado();
    this.alert(
      "success",
      "Certificado asociado",
      "El certificado fue asociado correctamente",
    );
    this.btnDisable = false;
    this.formAsociarCertificado.reset();
    this.modalService.dismissAll();
  }

  async excluirUserGroup(item: any) {
    const index = this.userArrayExcluir.findIndex(
      (x: any) => x.id_usuario_grupo === item.id_usuario_grupo,
    );
    const index2 = this.userArrayExcluir.indexOf(item.id_usuario_grupo);

    if (index === -1 && index2 === -1) {
      Swal.fire({
        title: "¡Excluir Usuario!",
        text: "¿Deseas excluir este usuario?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Excluir",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.userArrayExcluir.push(item);
          this.arrayIdUserGroup.push(item.id_usuario_grupo);
          this.alert("success", "¡Usuario Excluido!");
        }
      });
    } else {
      this.alert("warning", "El usuario ya fue excluido");
    }
  }

  incluirUserGroup(item: any) {
    const index = this.userArrayExcluir.findIndex(
      (x: any) => x.id_usuario_grupo === item.id_usuario_grupo,
    );
    const index2 = this.arrayIdUserGroup.indexOf(item.id_usuario_grupo);

    if (index != -1 && index2 != -1) {
      Swal.fire({
        title: "¡Revertir acción!",
        text: "¿Desea revertir la exclusión de este usuario?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Revertir",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.userArrayExcluir.splice(index, 1);
          this.arrayIdUserGroup.splice(index2, 1);
          this.alert("success", "Reversión realizada correctamente");
        }
      });
    }
  }

  async groupChange(content: any) {
    this.idGroup = content;

    if (this.idGroup) {
      this.getUserGroup();
    } else {
      this.userArrayExcluir = [];
      this.arrayIdUserGroup = [];
      this.currentItems = [];
      this.totalItems = 0;
    }
  }

  async getUserGroup() {
    this.spinner = true;
    this.userArrayExcluir = [];
    this.arrayIdUserGroup = [];
    let params = new HttpParams();
    params = params
      .set("page", this.currentPage)
      .set("limit", this.pageSize)
      .set("pagination", true)
      .set("id_grupo", String(this.idGroup));
    const result = await lastValueFrom(this.usurioService.userGroups(params));
    this.spinner = false;
    const headers: HttpHeaders = result.headers;
    this.currentItems = result.body.map((x: any, index: number) => {
      return {
        id_usuario_grupo: x.id,
        grupo: x.grupo.nombre,
        nombre: x.usuario.firstName + " " + x.usuario.lastName,
        correo: x.usuario.email,
      };
    });
    this.totalItems = Number(headers.get("X-Total-Count"));
  }

  getEsGrupo() {
    if (this.es_grupo && this.loteCertificadosGroup.length == 0) {
      this.alert(
        "info",
        "Grupo requerido",
        "Debe agregar un grupo antes de agregar un certificado",
      );
    }
  }

  async excluir() {
    const data = {
      id_grupo: this.idGroup,
      ids_usuario_grupo: this.arrayIdUserGroup,
      id_lote: this.idLote,
    };

    const result = await lastValueFrom(this.usurioService.guardarGrupo(data));

    if (result) {
      this.indexLoteCertificado();
      this.indexLoteCertificadoGroup();
      this.modalService.dismissAll();

      this.alert("success", "Grupo guardado correctamente");

      this.userArrayExcluir = [];
      this.arrayIdUserGroup = [];
      this.currentItems = [];
      this.totalItems = 0;
    }
  }

  activarCertificados() {
    if (this.certificadoClicked) return;

    this.certificadoBtn.nativeElement.click();
    this.certificadoClicked = true;
  }

  async searchMyCertificates() {
    await this.searchCertificateComponent!.searchMyCertificates();
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.getUserGroup();
  }

  onPageSizeChange(newSize: number): void {
    this.pageSize = newSize;
    this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño
    this.getUserGroup();
  }

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({
      icon: icontext,
      title: title,
      text: text,
    });
  }

  resultGroupSelected = async (data: any) => {
    if (data.success) {
      await this.indexLoteCertificado();
    }
  };
}
